import { create } from 'zustand'
import { supabase } from '@/lib/supabase'
import type { AuthUser, Participant } from '@/types'

interface AuthState {
  user:           AuthUser | null
  participant:    Participant | null
  loading:        boolean
  initialized:    boolean
  setUser:        (user: AuthUser | null) => void
  setParticipant: (p: Participant | null) => void
  setLoading:     (v: boolean) => void
  setInit:        (v: boolean) => void
  signOut:        () => Promise<void>
}

export const useAuthStore = create<AuthState>((set) => ({
  user:           null,
  participant:    null,
  loading:        true,
  initialized:    false,
  setUser:        (user)        => set({ user }),
  setParticipant: (participant) => set({ participant }),
  setLoading:     (v)           => set({ loading: v }),
  setInit:        (v)           => set({ initialized: v }),
  signOut: async () => {
    await supabase.auth.signOut()
    set({ user: null, participant: null })
  },
}))
